/**
 * @type {{ translation: ITranslationObject }}
 */
const es = {
  translation: {
    FIELDS: {
      REQUIRED: 'campo obligatorio',
      REQUIRED_EMPTY: 'Campo obligatorio no rellenado',
      INVALID_INPUT: 'El valor ingresado no es válido',
      WITHOUT_MASK: 'Sin mascarilla',
      PHONE_TYPE_COMERCIAL: 'Comercial',
      PHONE_TYPE_CELLPHONE: 'Teléfono móvil',
      PHONE_TYPE_RESIDENTIAL: 'Residencial',
      PHONE_TYPE_FAX: 'Fax',
      PHONE_TYPE_OTHERS: 'Otros',
      EMAIL_MAIN: 'Principal',
      ADD_EMAIL: 'Nuevo correo',
      INPUT_WITHOUT_OPTIONS: 'No hay opciones que coincidan con tu búsqueda',
      FILE_MAX_SIZE_ALLOWED: 'Tamaño máximo permitido del archivo: {{size}}',
      FILE_TOO_BIG_WARN: 'El archivo {{item}} más grande que {{size}}',
      CHOOSE_FILE: 'Seleccionar archivo',
      MASK_ERROR: 'Verifique si el campo se ha completado de acuerdo con la máscara seleccionada.',
      MASK_DROPDOWN: {
        MASK_IMG_BRA_ALT: 'Bandera de Brasil',
        MASK_IMG_USA_ALT: 'Bandera de los Estados Unidos',
        MASK_IMG_MEX_ALT: 'Bandera de México',
        MASK_IMG_ARG_ALT: 'Bandera de Argentina',
        MASK_IMG_CHL_ALT: 'Bandera de Chile',
        MASK_IMG_URY_ALT: 'Bandera de Uruguay',
        MASK_IMG_COL_ALT: 'Bandera de Colombia',
        MASK_IMG_PER_ALT: 'Bandera de Perú',
        MASK_IMG_NONE_ALT: 'Sin bandera',
      },
    },
    GENERICS: {
      TOASTER: {
        FORM_ERROR: 'Error al enviar el formulario',
        FORM_SUCCESS: 'Formulario enviado exitosamente',
      },
      LOADING: {
        SENDING_DATA: 'Enviando datos...',
        DONT_RELOAD_PAGE: 'Por favor, no recargue la página hasta que la operación haya finalizado.'
      },
      SENDING_FORM: 'Enviando formulario',
      EXTERNAL_FORM_TITLE: 'Forma externa | Powered by Ploomes',
      SEND: 'Enviar',
      HOUR: 'Hora',
      FORM_NOT_FOUND: 'No se ha encontrado un formulario'
    },
  },
};

export default es;
